module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\"> \r\n    <list-list :groups=\"groups\" :options=\"options\"/>\r\n</div>\r\n<loading-spinner v-else/>"


//////////////////
// WEBPACK FOOTER
// ./src/views/list/list.html
// module id = 16
// module chunks = 0